import React, {useState} from "react";
import {Button} from "@/components/ui/button";
import {Input} from "@/components/ui/input";
import {Label} from "@/components/ui/label";
import useModal, {Modal} from "@/hook/useModal";
import {Textarea} from "@/components/ui/textarea";
import useCreateWorkflow from "@/query/workflow/useCreateWorkflow";
import {WorkflowCreate, WorkflowLabels} from "@/model/Workflow";
import toast from "react-hot-toast";
import useRouteHandler from "@/hook/useRouteHandler";

export const CREATE_WORKFLOW_MODAL_ID = "create-workflow-modal-id";

interface CreateWorkflowModalProps {

}

const CreateWorkflowModal: React.FC<CreateWorkflowModalProps> = (props) => {
    const modal = useModal();
    const {moveToWorkflow} = useRouteHandler();
    const [name, setName] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const {mutateAsync: createWorkflow} = useCreateWorkflow();

    const onClickCancel = () => {
        modal.close(CREATE_WORKFLOW_MODAL_ID)
    }

    const onClickCreate = async () => {
        try {
            if (!name.trim()) {
                toast.error("Workflow name cannot be empty!");
                return;
            }

            const body: WorkflowCreate = {
                name: name,
                description: description,
                labels: [WorkflowLabels.SITEBUNNY_CHAT]
            }

            const workflow= await createWorkflow(body)
            modal.close(CREATE_WORKFLOW_MODAL_ID)
            moveToWorkflow(workflow._id)
        } catch (e) {
            toast.error("Error creating workflow")
        }
    }

    return (
        <Modal id={CREATE_WORKFLOW_MODAL_ID}
               size="md"
               title="Workflow 생성"
        >
            <div className="mt-8 flex flex-col gap-6">
                <div className="flex flex-col gap-4">
                    <Label>Workflow Name</Label>
                    <Input value={name}
                           onChange={(e) => setName(e.target.value)}
                           autoComplete="off"
                           placeholder="Input Workflow Name"
                           autoFocus
                           aria-label="workflow-name"
                    />

                    <Label>Description</Label>
                    <Textarea value={description}
                              onChange={(e) => setDescription(e.target.value)}
                              aria-label="description"
                              placeholder="Input Description"
                              rows={6}
                    />
                </div>
                <div className="flex justify-end gap-2">
                    <Button type="button" variant="outline" onClick={onClickCancel}>
                        취소
                    </Button>
                    <Button type="button" onClick={onClickCreate}>
                        생성
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default CreateWorkflowModal;
